import React from 'react';
import TodoItem from "./TodoItem";


const Todos = (props) => {
  let myStyle = {
    minHeight: "70vh",
    margin: "40px auto"
  }
  return (
    <div className="container" style={myStyle}>
     <h2>Todos List</h2><hr/>
     { props.todos.length === 0 ? "Todo List is Empty":
    props.todos.map((todo)=>{
      return(<TodoItem todo={todo} key={todo.Sno} onDelete={props.onDelete}/>) 
    })
  }
    </div>
  )
};

export default Todos  